<i18n>
{
  "fr": {
    "Export": "Exporter en Excel",
    "Title": "Rapport de vélocité de "
  }
}
</i18n>

<template>
  <section>
    <AppHeader :title="$t('Title') + ' ' + getUserById($route.query.user).user.displayName">
      <div class="row justify-content-end">
        <div class="col-auto">
          <ButtonExport
            :label="$t('Export')"
            @click="exportToExcel()"/>
        </div>
      </div>
    </AppHeader>
    <AppContainer>
      <BaseTabs slot="left">
        <BaseTab
          :to="{
            name: 'Velocity-Global',
            query: $route.query
          }"
          label="Global"/>
        <BaseTab
          v-for="projectTasks in projectsTasks"
          :key="projectTasks.projectName"
          :to="{
            name: 'Velocity-Details',
            params: { projectName: projectTasks.projectName },
            query: $route.query
          }"
          :label="$t(projectTasks.projectName)" />
      </BaseTabs>
      <router-view :key="$route.fullPath" />
    </AppContainer>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState('tasks', ['projectsTasks', 'loadedUser']),
    ...mapGetters('users', ['getUserById']),
  },
  created() {
    this.$store.dispatch('tasks/getListByProject', this.$route.query);
  },
  methods: {
    exportToExcel() {
      this.$store.dispatch('tasks/exportToExcel');
    },
  },
};
</script>
